import PropTypes from 'prop-types'
import userRoles from 'constants/userRoles'

export default PropTypes.oneOf([
  userRoles.AGENT,
  userRoles.ADMIN,
  userRoles.FLEET_MANAGER,
  userRoles.VESSEL_MANAGEMENT,
  userRoles.SHIP,
])
